import iconChatSubmit from "../../../../assets/icon_chat_submit.svg";
import { FiPlus } from "react-icons/fi";
import { FaPaperPlane } from "react-icons/fa";
import FAQModal from "../Modal/FAQModal";
import { useLocation } from "react-router-dom";
import useFAQ from "../../hooks/bot/useFAQ";
import { useState } from "react";
import { FaCircleInfo } from "react-icons/fa6";

const Input = ({ onKeyDown, onKeyUp, onSendButtonClick, inputRef, search, brandId }) => {
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const { realtiemList, questionList, handleOnClick } = useFAQ({
    search,
    closeModal,
  });
  const { pathname } = useLocation();
  return (
    <>
      <div className={`fixed bottom-0 left-0 flex items-center justify-between w-full py-3 px-3  bg-white shadow-2xl gap-2.5 ${brandId === "LD" && 'rounded-tl-3xl rounded-tr-3xl'}`}>
        {pathname === "/chat" && brandId !== "LD" && (
          <button onClick={() => openModal()}>
            <FiPlus className="text-3xl" />
          </button>
        )}

        <div className="flex-1 ">
          <label className={`flex items-center gap-2 input rounded-[60px] ${brandId === "LD" ? 'bg-transparent border border-gray-300 !pr-0' : 'bg-neutral-100' }`}>
            <input
              ref={inputRef}
              type="text"
              className="w-full"
              placeholder="궁금한 사항을 입력해 주세요"
              onKeyDown={onKeyDown}
              onKeyUp={onKeyUp}
            />
            {
              brandId === "LD" ? (
                <button
                  className="px-4 py-3 bg-brand-secondary rounded-[50px] text-white w-12 h-12"
                  onClick={() => {
                    setTimeout(() => {
                      onSendButtonClick();
                    }, 10);
                  }}
                >
                  <FaPaperPlane />
                </button>
              ) : (
                <button
                  onClick={() => {
                    setTimeout(() => {
                      onSendButtonClick();
                    }, 10);
                  }}
                >
                  <img src={iconChatSubmit} alt="" />
                </button>
              )
            }
          </label>
          {
            pathname !== "/chat" && (
            <div className="flex flex-row text-center pt-2 gap-1 items-center justify-center">
              <FaCircleInfo /> 
              <div className="flex text-sm font-medium tracking-tighter justify-center text-gray-600">본 상담은 AI의 도움을 받아 답변을 작성/검토할 수 있습니다.</div>
            </div>
            )
          }
        </div>
      </div>
      <FAQModal
        realtiemList={realtiemList}
        questionList={questionList}
        search={search}
        handleOnClick={handleOnClick}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
      />
    </>
  );
};

export default Input;
